import styles from 'css/src/components/common/mentions/ReferenceMention.module.scss';

import React from 'react';

import { KIND_ICON, KIND_LABEL } from './referenceKinds';
import type { Reference, ReferenceKind } from './ReferenceMentionNode';

interface ReferencePreviewCardProps {
    kind: ReferenceKind;
    /** Name from the mention itself, used when the object can't be resolved. */
    name: string;
    reference?: Reference | null;
    /** Appended after the kind label, e.g. "click to change". */
    hint?: string;
}

/**
 * Falls back to the name carried in the mention token when the object isn't in
 * the caller's reference list — an old message can mention a deleted video.
 */
const ReferencePreviewCard: React.FC<ReferencePreviewCardProps> = ({
    kind,
    name,
    reference,
    hint,
}) => (
    <div className={styles['reference-popover__preview']}>
        {reference?.thumbUrl ? (
            <img className={styles['reference-popover__thumb']} src={reference.thumbUrl} alt="" />
        ) : reference?.swatches?.length ? (
            <span className={styles['reference-popover__swatches']}>
                {reference.swatches.slice(0, 6).map((color, index) => (
                    // Colours have no stable id and can repeat.
                    <span key={`${color}-${index}`} style={{ backgroundColor: color }} />
                ))}
            </span>
        ) : (
            <span className={styles['reference-popover__thumb-placeholder']}>
                <i translate="no" className="material-symbols-outlined">
                    {KIND_ICON[kind]}
                </i>
            </span>
        )}
        <span className={styles['reference-popover__name']}>{name}</span>
        {reference?.detail && (
            <span className={styles['reference-popover__detail']}>{reference.detail}</span>
        )}
        <span className={styles['reference-popover__kind']}>
            {hint ? `${KIND_LABEL[kind]} · ${hint}` : KIND_LABEL[kind]}
        </span>
    </div>
);

export default ReferencePreviewCard;
